/**
 * Überschrift einer Seite im Header, über der Inhaltsspalte: wo man ist.
 *
 *   Übersicht                            ← Titel
 *
 * Ein geöffneter Datensatz trägt davor die Seite, aus der er kommt – anklickbar, das ist der
 * Rückweg (`back`):
 *
 *   Nachweise › Schallimmissionsprognose Hohe Mark
 *
 * Modul und Antrag stehen nicht dabei – die zeigt die Sidebar links daneben, den Projektnamen
 * der Header über ihr.
 */
import React from "react";
import { Box, Typography } from "@mui/material";
import { colors, fonts } from "../../styles/theme";
import ZurueckLink from "../common/inputs/ZurueckLink";

export interface PageTitleBack {
  /** Ziel des Rückwegs, z. B. „Nachweise“ */
  label: string;
  onClick: () => void;
}

interface SeitenTitelProps {
  /** Rückweg vor dem Titel */
  back?: PageTitleBack;
  titel: string;
}

const SeitenTitel: React.FC<SeitenTitelProps> = ({ back, titel }) => (
  <Typography
    component="div"
    variant="h5"
    sx={{
      display: "flex",
      alignItems: "baseline",
      gap: 1,
      minWidth: 0,
      fontWeight: fonts.weights.medium,
      lineHeight: 1.3,
    }}
  >
    {back && (
      <>
        <ZurueckLink label={back.label} onClick={back.onClick} />
        <Box component="span" aria-hidden sx={{ color: colors.text.disabled }}>
          ›
        </Box>
      </>
    )}
    <Box
      component="h1"
      title={titel}
      sx={{
        m: 0,
        font: "inherit",
        color: colors.text.primary,
        minWidth: 0,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {titel}
    </Box>
  </Typography>
);

export default SeitenTitel;
